import { BaseSelectors } from '@makemydeal/dr-activities-common';
import { CreditAppStatus } from '@makemydeal/dr-sales-checkin-types';
import type { StateTree } from '../types/StateTree';
import type { AdditionalSelectors } from '../types';
import type { CreditAppState } from '@makemydeal/dr-sales-checkin-store';

export class Selectors extends BaseSelectors {
    constructor(public sliceName: string, public additionalSelectors: AdditionalSelectors) {
        super(sliceName);
    }

    /**
     * Get the slice of state for this activity
     * @param state Entire State Tree
     */
    getState = (state: any): CreditAppState => {
        return super.getState(state);
    };

    getCreditAppId = (state: StateTree): string | null => {
        return this.getState(state).creditAppId ?? null;
    };

    getDealRefId = (state: StateTree): string | null => {
        return this.getState(state).dealRefId ?? null;
    };

    getCreditAppStatus = (state: StateTree): CreditAppStatus | null => {
        return this.getState(state).status ?? null;
    };

    isCreditAppCompleted = (state: StateTree): boolean => {
        const status = this.getCreditAppStatus(state);
        return status === CreditAppStatus.SUBMITTED || status === CreditAppStatus.PENDING;
    };

    getShopper = (state: StateTree): any | null => {
        return this.getState(state).shopper ?? null;
    };
}
